import styled from '@emotion/styled';
import { COLORS } from '../../constants';

export const DRAGGABLE_FONT = `
  font-family: Mulish;
  font-style: normal;
  font-size: 23px;
  font-weight: 600;
  line-height: normal;
  text-align: center;
`;

export const StyledDraggableLabel = styled.div<{
  isHidden: boolean;
  labelColor: string;
  isHighlighted: boolean;
}>`
  box-sizing: border-box;
  z-index: 41;
  position: absolute !important;

  ${DRAGGABLE_FONT}

  border-radius: 8px;

  display: ${({ isHidden }) => (isHidden ? 'none' : 'block')};
  background: ${({ labelColor, isHighlighted }) => (labelColor && !isHighlighted ? labelColor : COLORS.debianRed)};
  user-select: none;
  transform: translate(-50%, -50%);

  input {
    color: ${({ isHighlighted }) => (isHighlighted ? COLORS.white : COLORS.black)};
  }
`;
